/** כל מפתחות TanStack Query במקום אחד (מסמך התכנון, סעיף 4.3). */
export const qk = {
  settings: ['settings'] as const,
  me: ['me'] as const,
  home: {
    all: ['home'] as const,
    nextShift: ['home', 'nextShift'] as const,
    pendingAcks: ['home', 'pendingAcks'] as const,
  },
  channels: ['channels'] as const,
  messages: (channelId: string) => ['messages', channelId] as const,
  period: (periodId: string) => ['period', periodId] as const,
  myWeek: (weekStartKey: string) => ['myWeek', weekStartKey] as const,
  teamDay: (branchId: string, date: string) => ['teamDay', branchId, date] as const,
  constraints: (periodId: string) => ['constraints', periodId] as const,
  sales: { mine: ['sales', 'mine'] as const },
  notifications: ['notifications'] as const,
};
